<template>
    <div>
        <el-divider>{{ $t('私有属性') }}</el-divider>
        <el-form-item :label="$t('导入标题')">
            <el-input v-model="data.uplabel" :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('导出标题')">
            <el-input v-model="data.downlabel" :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('导出内容')">
            <l-select v-model="data.context"
                :options="[{ value: 'model', label: '模板数据' }, { value: 'file', label: '文件数据' }]"></l-select>
        </el-form-item>
        <el-form-item :label="$t('显示提示')">
            <el-switch v-model="data.isTip"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('是否只读')">
            <el-switch v-model="data.readonly"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('是否只写')">
            <el-switch v-model="data.writeonly"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('是否可见')">
            <el-switch v-model="data.display"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('最大上传数')">
            <el-input-number v-model="data.limit" controls-position="right" :placeholder="$t('请输入')"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('最大保留数')">
            <el-input-number v-model="data.keep" controls-position="right" :placeholder="$t('请输入')"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('关联表格')">
            <l-select v-model="data.gridtable" :options="gridtableOptions" @change="handleGridtableChange"></l-select>
        </el-form-item>
        <el-form-item >
            <!--l-codeeditor :label="$t('导入前处理')" :showBtns="true" v-model="data.eventCode" ></l-codeeditor-->
            <l-code-editor-button 
                        key="edit"  
                        type="button" 
                        :btnText="$t('导入前处理')"
                        :theme="$t('eclipse')"
                        v-model="data.eventCode"
                        mode="application/javascript"
                        class="el-button el-button--text el-button--mini">
                        <span>编辑</span>                        
                    </l-code-editor-button>
        </el-form-item>
        <el-form-item :label="$t('原数据处理')">
            <l-radio v-model="data.source" border
                :options="[{ value: 'keep', label: '保留' }, { value: 'clear', label: '清除' }]"></l-radio>
        </el-form-item>
        <el-form-item :label="$t('重复处理')">
            <l-select v-model="data.doing"
                :options="[{ value: 'skip', label: '跳过' }, { value: 'overwrite', label: '覆盖' }, { value: 'update', label: '更新' }]"></l-select>
        </el-form-item>
        <el-form-item :label="$t('错误处理')">
            <l-select v-model="data.error"
                :options="[{ value: 'stop', label: '终止' }, { value: 'skip', label: '跳过' }]"></l-select>
        </el-form-item>

        <el-divider>{{ $t('数据列配置') }}</el-divider>
        <template >
            <draggable v-model="data.columns">            
                <div class="reg-item" :key="index"  v-for="(item, index) in data.columns">
                    <el-form-item :label="$t('表格字段')" style="margin-bottom:8px;">
                        <l-select v-model="item.prop" :options="myColNameList"></l-select>
                    </el-form-item>
                    <el-form-item :label="$t('导入列名称')" style="margin-bottom:8px;">
                        <el-input v-model="item.label" :placeholder="$t('请输入')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('是否关键列')" style="margin-bottom:8px;">
                        <el-switch v-model="item.primary"></el-switch>
                    </el-form-item>
                    <el-form-item :label="$t('是否唯一列')" style="margin-bottom:8px;">
                        <el-switch v-model="item.unique"></el-switch>
                    </el-form-item>
                        <el-form-item label="关联类型">
                            <l-select :placeholder="$t('请选择')" :options="relationTypeOptions" v-model="item.relationType"
                                @change="handleRelationChange">
                            </l-select>
                        </el-form-item>
                        <el-form-item v-if="item.relationType == 2" label="数据选项">
                            <l-tree-select :placeholder="$t('请选择')" :options="lr_dataItemClassifysTree" v-model="item.DataItemCode">
                            </l-tree-select>
                        </el-form-item>
                        <el-form-item v-if="item.relationType == 3" label="数据选项">
                            <l-select :placeholder="$t('请选择')" :bindItem="item" :options="lr_dataSource" labelKey="f_Name"
                                valueKey="f_Code" v-model="item.DataSourceId" @change="handleDataSourceChange">
                            </l-select>
                        </el-form-item>
                        <el-form-item v-if="item.relationType == 3" label="导入字段">
                            <l-select :placeholder="$t('请选择')" :options="colNames" v-model="item.DataSourceExcelId">
                            </l-select>
                        </el-form-item>
                        <el-form-item v-if="item.relationType == 3" label="保存字段">
                            <l-select :placeholder="$t('请选择')" :options="colNames" v-model="item.DataSourceDBId">
                            </l-select>
                        </el-form-item>
                        <el-form-item v-if="item.relationType == 4" label="固定数值" prop="f_Value">
                            <el-input v-model="item.fixedValue"></el-input>
                        </el-form-item>

                    <el-button :title="$t('删除')" @click="handleRemoveCol(index)" class="reg-item-delete" circle plain
                        size="mini" type="danger">
                        <i class="el-icon-close"></i>
                    </el-button>
                </div>
            </draggable>
        </template>
        <el-button class="ml-8" type="primary" size="mini" @click="handleAddCol(data)">{{ $t('添加列') }}</el-button>
    </div>
</template>

<script>
export default {
    name: "config-uploadmodel",
    inject: ["formDesign"],
    props: ['data'],
    data() {
        return {
            uplabel: '导入',
            downlabel: '导出',
            doingOptions: [
                { value: 'clearAll', label: '清除原数据' },
                { value: 'append', label: '追加现有数据' },
                { value: 'right', label: '更新现有数据' }],
            relationTypeOptions: [
                { value: 0, label: "无关联" },
                { value: 1, label: "GUID" },
                { value: 2, label: "数据字典" },
                { value: 3, label: "数据来源" },
                { value: 4, label: "固定数据" },
                { value: 5, label: "登录者ID" },
                { value: 6, label: "登录者名字" },
                { value: 7, label: "导入时间" }
            ],
            rules2: {
                relationType: [
                    { required: true, message: '请输选择关联类型' }
                ],
                DataItemCode: [
                    { required: true, message: '请选择数据字典' }
                ],
                DataSourceId: [
                    { required: true, message: '请选择数据源' }
                ],
                DataSourceExcelId: [
                    { required: true, message: '请选择导入字段' }
                ],
                DataSourceDBId: [
                    { required: true, message: '请选择保存字段' }
                ],
                fixedValue: [
                    { required: true, message: '请填写固定数值' }
                ],
            },
            colNames: [],
            myColNameList: [],
        }
    },
    computed: {
        gridtableOptions() {
            return this.formDesign.nowComponentList.filter(t => t.type == "gridtable")
                .map(t => {
                    return { value: t.prop, label: t.label }
                })
        }
    },
    mounted() {    
        this.lr_loadDataItemClassifys()
        this.lr_loadDataSourceList()
        this.formDesign.nowComponentList.filter(t => t.type == "gridtable" && this.data.gridtable == t.prop)
            .forEach(t => {
                t.children.forEach(t1 => {
                    this.myColNameList.push({ value: t1.prop, label: t1.label });
                });
            });
    },
    methods: {
        handleGridtableChange(selectedValue) {
            this.myColNameList = []
            if (!selectedValue)
                return;
            this.formDesign.nowComponentList.filter(t => t.type == "gridtable" && selectedValue.value == t.prop)
                .forEach(t => {
                    t.children.forEach(t1 => {
                        this.myColNameList.push({ value: t1.prop, label: t1.label });
                    });
                });
        },
        handleRemoveCol(index) {
            this.data.columns.splice(index, 1)
        },
        handleAddCol() {
            if(!this.data.columns){
                this.$set(this.data, 'columns', [])
            }
            this.data.columns.push({
            });
        },
        handleRelationChange() {
            //this.formData2.f_DataItemCode = ''
            //this.formData2.f_DSourceId = ''
            //this.formData2.f_DSourceExcelId = ''
            //this.formData2.f_DSourceDBId = ''
            //this.formData2.f_Value = ''
        },
        async handleDataSourceChange(item, bindItem) {
            if (this.$validatenull(item)) {
                bindItem.DSourceExcelId = ''
                bindItem.DSourceDBId = ''
                this.colNames = []
            }
            else {
                await this.lr_loadDataSourceColNames(item.f_Code, false)
                const _data = this.lr_dataSourceCol[item.f_Code].map(t => { return { value: t, label: t } })
                this.colNames = _data
                bindItem.DSourceExcelId = _data[0].value
                bindItem.DSourceDBId = _data[0].value
            }
        },
        handleCustmerReg() {
            var hintList = this.formDesign.nowComponentList.map(t => `/*${t.label}*/"${t.prop}"`);
            var thisList = [`$this.httpPost({url,params,data,function(res){
            if(res){

            }
        }})`]
            var pList = [`$p.tableRow/*当前行数据*/`, `$p.tableIndex/*当前行索引*/`]
            hintList.push(...thisList)
            hintList.push(...pList)
            var alertString = `
        $this: 当前表单的引用<br />
        $p: 事件参数的引用<br />`;
            this.$refs.codedlg.open(alertString, hintList)
        }
    }
}
</script>
